import { setContext, getContext } from "svelte";

class PureButtonContext {
  hovered = $state(false);
  focused = $state(false);
}

const PURE_BUTTON_CONTEXT = Symbol("PureButtonContext");

export const createPureButtonContext = () => {
  const ctx = new PureButtonContext();
  setContext(PURE_BUTTON_CONTEXT, ctx);
  return ctx;
};

export const getPureButtonContext = () => getContext(PURE_BUTTON_CONTEXT);
